import { render, staticRenderFns } from "./accurate-study.vue?vue&type=template&id=fd11f0fc&scoped=true"
import script from "./accurate-study.vue?vue&type=script&lang=js"
export * from "./accurate-study.vue?vue&type=script&lang=js"
import style0 from "./accurate-study.vue?vue&type=style&index=0&id=fd11f0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd11f0fc",
  null
  
)

export default component.exports